import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Typography, Container } from "@mui/material";
import { uploadSelector, updateFiles } from "../store/slices/upload";
import { useDispatch, useSelector } from "react-redux";
import FileUploader from "../common/fileUploader";
import _ from "lodash";

const byteArrayToBase64 = (byteArray) => {
  return btoa(
    byteArray.reduce((data, byte) => data + String.fromCharCode(byte), "")
  );
};

export default function AlertDialog({ toggle, open }) {
  const [bytearr, setBytearr] = React.useState([]);
  const [error, setError] = React.useState(null);
  const dispatch = useDispatch();
  const handleProcessFile = (fileItem) => {
    return new Promise((resolve, reject) => {
      // Check if the file type is valid.
      //   if (!validTypes.includes(fileItem.file.type)) {
      //     reject(new Error(`Invalid file type: ${fileItem.file.type}`));
      //     return;
      //   }
      //   if(_.includes(_.map(requestPhotos,'fileName'),fileItem.filename)){
      //     reject(new Error(`File already exists: ${fileItem.filename}`));
      //     return;
      //   }

      const reader = new FileReader();
      reader.onload = () => {
        const arrayBuffer = reader.result;
        const uint8Array = new Uint8Array(arrayBuffer);

        // Construct the object with file details.
        const obj = {
          fileName: fileItem.filename,
          fileType: fileItem.file.type,
          content: null, // Reserved for future use.
          contentBase64: byteArrayToBase64(uint8Array), // Base64 encoding of file content.
        };
        resolve(obj);
      };

      // Handle file reading errors.
      reader.onerror = () => {
        reject(new Error("Failed to process file" + fileItem.filename));
      };

      // Read the file as an ArrayBuffer.
      reader.readAsArrayBuffer(fileItem.file);
    });
  };
  const handleData = async (files) => {
    try {
      const results = await Promise.allSettled(
        files.map((file) => handleProcessFile(file))
      );
      const validFiles = _.map(
        _.filter(results, (result) => result.status === "fulfilled"),
        "value"
      ); // Extract valid files.
      setBytearr(validFiles);
    } catch (error) {
      console.error("Error processing files:", error);
    }
  };
  const generateBase64Images = () => {
    if (bytearr.length > 0) {
      dispatch(
        updateFiles({
          requestProfileId: localStorage.getItem("userId"),
          files: bytearr,
        })
      );
      toggle();
    }
    else {
      setError("Files not selected.");
    }
  };
  return (
    <div>
      <Dialog
        open={open}
        onClose={toggle}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="lg"
      >
        <DialogTitle id="alert-dialog-title">
          <Typography variant="h5">{"Upload Files"}</Typography>
        </DialogTitle>
        <DialogContent sx={{ padding: '10px !important' }}>
          <Container maxWidth="md">
            <FileUploader
              returnFunc={handleData}
              slotProps={{
                filepond: {
                  maxFiles: 5,
                },
              }}
            />
          </Container>
          {error && <Typography color={'red'} ml={3}>{error}</Typography>}
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={generateBase64Images}>
            Save
          </Button>
          <Button variant="text" onClick={toggle}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
